import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import { usePreloadedQuery} from 'react-relay'

import SettingsWrapper from '../../../../components/Settings/SettingsWrapper'
import {PALETTE} from '../../../../styles/paletteV3'
import AtlassianProviderRow from '../ProviderRow/AtlassianProviderRow'
import AzureDevOpsProviderRow from '../ProviderRow/AzureDevOpsProviderRow'
import GcalProviderRow from '../ProviderRow/GcalProviderRow'
import GitHubProviderRow from '../ProviderRow/GitHubProviderRow'
import GitLabProviderRow from '../ProviderRow/GitLabProviderRow'
import JiraServerProviderRow from '../ProviderRow/JiraServerProviderRow'
import MSTeamsProviderRow from '../ProviderRow/MSTeamsProviderRow'
import MattermostProviderRow from '../ProviderRow/MattermostProviderRow'
import SlackProviderRow from '../ProviderRow/SlackProviderRow'







const StyledWrapper = styled(SettingsWrapper)({
  display: 'block'
})

const Note = styled('div')({
  paddingTop: 29,
  paddingBottom: 25,
  fontSize: 13
})

const Heading = styled('div')({
  color: PALETTE.SLATE_700,
  fontSize: 16,
  fontWeight: 600
})

const AvailableHeading = styled(Heading)({
  paddingTop: 16
})

const query = graphql`
  query ProviderListQuery($teamId: ID!) {
    viewer {
      ...AtlassianProviderRow_viewer
      ...JiraServerProviderRow_viewer
      ...GitHubProviderRow_viewer
      ...GitLabProviderRow_viewer
      ...MattermostProviderRow_viewer
      ...SlackProviderRow_viewer
      ...AzureDevOpsProviderRow_viewer
      ...MSTeamsProviderRow_viewer
      ...GcalProviderRow_viewer

      teamMember(teamId: $teamId) {
        integrations {
          atlassian {
            accessToken
          }
          jiraServer {
            auth {
              id
              isActive
            }
            sharedProviders {
              id
            }
          }
          gcal {
            auth {
              id
            }
          }
          github {
            accessToken
          }
          gitlab {
            auth {
              provider {
                scope
              }
            }
          }
          mattermost {
            auth {
              provider {
                id
              }
            }
          }
          slack {
            isActive
          }
          azureDevOps {
            auth {
              accessToken
            }
          }
          msTeams {
            auth {
              provider {
                id
              }
            }
          }
        }
      }
    }
  }
`

const ProviderList = (props) => {
  const {queryRef, retry, teamId} = props
  const data = usePreloadedQuery(query, queryRef)
  const {viewer} = data
  const integrations = _optionalChain([viewer, 'access', _ => _.teamMember, 'optionalAccess', _2 => _2.integrations])

  const allIntegrations = [
    {
      name: 'Atlassian',
      connected: !!_optionalChain([integrations, 'optionalAccess', _3 => _3.atlassian, 'optionalAccess', _4 => _4.accessToken]),
      component: (
        _jsx(AtlassianProviderRow, { teamId: teamId, retry: retry, viewer: viewer,}, "atlassian" )
      )
    },
    {
      name: 'Jira Data Center',
      connected:
        !!_optionalChain([integrations, 'optionalAccess', _5 => _5.jiraServer, 'optionalAccess', _6 => _6.auth, 'optionalAccess', _7 => _7.isActive]) && _optionalChain([integrations, 'access', _8 => _8.jiraServer, 'optionalAccess', _9 => _9.sharedProviders, 'access', _10 => _10[0]]),
      component: _jsx(JiraServerProviderRow, { teamId: teamId, viewerRef: viewer,}, "jira" )
    },
    {
      name: 'GitHub',
      connected: !!_optionalChain([integrations, 'optionalAccess', _11 => _11.github, 'optionalAccess', _12 => _12.accessToken]),
      component: _jsx(GitHubProviderRow, { teamId: teamId, viewer: viewer,}, "github" )
    },
    {
      name: 'GitLab',
      connected: !!_optionalChain([integrations, 'optionalAccess', _13 => _13.gitlab, 'access', _14 => _14.auth]),
      component: _jsx(GitLabProviderRow, { teamId: teamId, viewerRef: viewer,}, "gitlab" )
    },
    {
      name: 'Mattermost',
      connected: !!_optionalChain([integrations, 'optionalAccess', _15 => _15.mattermost, 'access', _16 => _16.auth]),
      component: _jsx(MattermostProviderRow, { teamId: teamId, viewerRef: viewer,}, "mm" )
    },
    {
      name: 'Slack',
      connected: _optionalChain([integrations, 'optionalAccess', _17 => _17.slack, 'optionalAccess', _18 => _18.isActive]),
      component: _jsx(SlackProviderRow, { teamId: teamId, viewer: viewer,}, "slack" )
    },
    {
      name: 'Azure DevOps',
      connected: !!_optionalChain([integrations, 'optionalAccess', _19 => _19.azureDevOps, 'access', _20 => _20.auth, 'optionalAccess', _21 => _21.accessToken]),
      component: _jsx(AzureDevOpsProviderRow, { teamId: teamId, viewerRef: viewer,}, "azure" )
    },
    {
      name: 'MS Teams',
      connected: !!_optionalChain([integrations, 'optionalAccess', _22 => _22.msTeams, 'access', _23 => _23.auth]),
      component: _jsx(MSTeamsProviderRow, { teamId: teamId, viewerRef: viewer,}, "teams" )
    },
    {
      name: 'Gcal Integration',
      connected: !!_optionalChain([integrations, 'optionalAccess', _24 => _24.gcal, 'optionalAccess', _25 => _25.auth]),
      component: _jsx(GcalProviderRow, { viewerRef: viewer, teamId: teamId,}, "gcal" )
    }
  ]

  const connectedIntegrations = allIntegrations
    .filter((integration) => integration.connected)
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((integration) => integration.component)

  const availableIntegrations = allIntegrations
    .filter((integration) => !integration.connected)
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((integration) => integration.component)

  return (
    _jsxs(StyledWrapper, { children: [
      _jsx(Note, { children: "Each team member must add the integrations they want to use. Integrations are scoped to the team where you add them."


      })

      , connectedIntegrations.length > 0 && _jsx(Heading, { children: "Connected"})

      , connectedIntegrations

      , availableIntegrations.length > 0 && _jsx(AvailableHeading, { children: "Available"})

      , availableIntegrations
    ]})
  )
}

export default ProviderList
